var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPantheon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 24,
    viewBox: "0 0 164 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_6155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.04 5.15C38.56 5.15 39.82 5.33 40.84 6.24C41.95 7.21 42.22 8.58 42.22 9.55C42.22 11.73 40.89 13.88 37.44 13.88H35.97V20.6H34.29V5.15H37.03H37.04ZM35.98 12.26H37.36C39.35 12.26 40.55 11.24 40.55 9.46C40.55 7 38.31 6.78 37.22 6.78H35.98V12.27V12.26ZM54.95 16.24H48.52L46.71 20.59H44.85L51.8 4.4L58.57 20.59H56.71L54.94 16.24H54.95ZM54.29 14.62L51.76 8.44L49.18 14.62H54.3H54.29ZM63.87 20.59V4.5L75.64 17.12V5.15H77.32V21.29L65.55 8.67V20.59H63.87ZM88.09 6.77V20.59H86.41V6.77H82.74V5.15H91.75V6.77H88.08H88.09ZM98.87 11.42H106.61V5.15H108.29V20.59H106.61V13.04H98.87V20.59H97.19V5.15H98.87V11.42ZM123.18 6.77H117.02V11.35H122.99V12.97H117.02V18.97H123.18V20.59H115.35V5.15H123.18V6.77ZM128.61 12.88C128.61 8.27 132.12 4.89 136.47 4.89C140.82 4.89 144.33 8.27 144.33 12.88C144.33 17.49 140.84 20.87 136.47 20.87C132.1 20.87 128.61 17.47 128.61 12.88ZM130.33 12.88C130.33 16.42 133.07 19.25 136.47 19.25C139.87 19.25 142.6 16.43 142.6 12.88C142.6 9.33 139.86 6.51 136.47 6.51C133.08 6.51 130.33 9.33 130.33 12.88ZM150.57 20.59V4.5L162.34 17.12V5.15H164.02V21.29L152.25 8.67V20.59H150.57ZM9.48 7.39V24H7.81V5.68H18.05V7.38H9.48V7.39ZM11.46 11.36V24H13.13V13.06H17.76C21.29 13.06 24.15 10.14 24.15 6.53C24.15 2.92 21.29 0 17.76 0H0V1.7H17.77C20.38 1.7 22.49 3.86 22.49 6.53C22.49 9.2 20.38 11.36 17.77 11.36H11.46ZM1.67 5.68V24H0V5.68H1.67ZM5.56 24V5.68H3.89V24H5.56Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_6155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPantheon);
export default __webpack_public_path__ + "static/media/pantheon.50511d4971ca831996bc185e8203f8fb.svg";
export { ForwardRef as ReactComponent };